import type { UseFormReturn } from "react-hook-form";
import { z } from "zod";

import type { Product } from "@/types";

import type { AddProductFormSchema } from "./hooks/schemas/use-add-product-form-schema";
import type { EditProductFormSchema } from "./hooks/schemas/use-edit-product-form-schema";

export type ProductListItem = Product & {
  key?: string;
};

export type AddProductModalState = {
  opened: boolean;
};

export type AddProductModalStep = "delivery" | "category";

export type ProductDeliveryType = "manual" | "automatic";

export const productCategoryEnum = z.enum(["api", "software", "connectivity"]);

export type ProductCategoryType = z.infer<typeof productCategoryEnum>;

export const productListSortEnum = z.enum([
  "a-z",
  "z-a",
  "newest",
  "oldest",
  "high-to-low",
  "low-to-high"
]);

export type ProductListSortValue = z.infer<typeof productListSortEnum>;

export type ProductIndustryCategory = {
  slug_name: string;
  name: string;
};

export type ProductFormProps = {
  formMethods: UseFormReturn<AddProductFormSchema | EditProductFormSchema>;
  productCategory: ProductCategoryType;
};
